import { render, staticRenderFns } from "./BranchAdmin.vue?vue&type=template&id=550cd626&scoped=true"
import script from "./BranchAdmin.vue?vue&type=script&lang=js"
export * from "./BranchAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cd626",
  null
  
)

export default component.exports